import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelHasAsset } from '@/modules/contact/models/ModelHasAsset';

export class AssetCoOwner extends BaseEntityModel {
  id?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  type?: string;
  pivot: ModelHasAsset;

  constructor(model: Partial<AssetCoOwner> = {}) {
    super(model);

    this.id = model.id;
    this.firstName = model.firstName;
    this.middleName = model.middleName;
    this.lastName = model.lastName;
    this.type = model.type;
    this.pivot = ModelHasAsset.mapModel(model.pivot);
  }

  get fullName(): string | null {
    return !!this.firstName || !!this.lastName
      ? [this.firstName, this.middleName, this.lastName].filter(Boolean).join(' ')
      : null;
  }

  setShareOfOwnership(value: number): void {
    this.pivot.shareOfOwnership = value;
  }
}
